import axios from "axios";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import ChangePasswordModal from "../../Components/Admin/ChangePasswordModal";
import Navbar from "../../Components/Navbar";
import Table from "../../Components/Users/SubRegistrarTable";
import Config from "../../Config";

import { MdAdd } from "react-icons/md";
import { useSelector } from "react-redux";
import {
  BoxContainer,
  Page,
  Underline,
} from "../../Components/Styles/PageStyles";
import AddSubRegistrarModel from "../../Components/Users/AddSubRegistrarModel";
import DeleteSubRegistrar from "../../Components/Users/DeleteSubRegistrar";
import EditSubRegistrarModel from "../../Components/Users/EditSubRegistrarModel";

const SubRegistrar = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [changePasswordModel, setChangePasswordModel] = useState(false);

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [selectedData, setSelectedData] = useState("");

  const [editUser, setEditUser] = useState(false);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("type", 8);
    return await axios.post(`${Config.apiUrl}/getusers`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const { isLoadingFetch, error, data, refetch, isRefetchingFetch } = useQuery(
    "financeList",
    fetchFunction
  );
  //console.log(data);

  //------ Upload Excel File ------
  const postFunction = async (file) => {
    if (file !== null && file !== undefined) {
      const body = new FormData();
      body.append("file", file[0]);

      return await axios.post(Config.AdminUploadApi, body, {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    } else throw Error("error");
  };

  const onSuccess = (data) => {
    refetch();
    setOpenUploadModel(false);
  };

  const onError = (data) => {
    setOpenUploadModel(false);
  };

  const { isLoading: uploadLoading, mutate: uploadExcelFile } = useMutation(
    postFunction,
    { onSuccess, onError }
  );

  //------- Add Single Entry -------
  const SingleEntryPostFunction = async (values) => {
    const body = new FormData();
    body.append("fName", values.fName);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("clubName", "National Sports Council of Tanzania");
    body.append("password", values.password);
    body.append("userType", values.type);
    return await axios.post(`${Config.apiUrl}/register`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onSingleEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success("Registrar Assistant added successfully");
      // toast.success(data?.data?.msg || "Success");
      refetch();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setOpenUploadModel(false);
  };

  const onSingleEntryError = (data) => {
    setOpenUploadModel(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: SingleEntryLoading, mutate: postSingleEntry } =
    useMutation(SingleEntryPostFunction, {
      onSuccess: onSingleEntrySuccess,
      onError: onSingleEntryError,
    });

  //------- Edit Single Entry -------
  const EditSingleEntryFunction = async (values) => {
    const body = new FormData();
    body.append("fName", values.fName);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("userType", values.type);

    return await axios.post(`${Config.apiUrl}/edituser`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success("Registrar Assistant updated successfully");
      // toast.success(data?.data?.msg || "Success");
      refetch();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    refetch();
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editSingleEntry } = useMutation(
    EditSingleEntryFunction,
    {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    }
  );

  //Get HostNames Province api
  const getHostNamesFunction = async () =>
    await axios.get(Config.GetHostNamesandProvince, Config.AxiosConfig);

  const {
    data: hostNamesandProvince,
    error: hostNamesError,
    isLoading: hostNamesLoading,
  } = useQuery("GetHostNamesandProvince", getHostNamesFunction);
  // end of GetHostNamesandProvince api

  // change password
  const changePasswordFunction = async (values) => {
    const body = new FormData();
    body.append("password", values.password);
    body.append("email", selectedData.email);
    //console.log( selectedData.email);
    body.append("confirmPassword", values.confirmPassword);
    return await axios.post(Config.apiUrl + "/changepasswordbyadmin", body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onChangePasswordSuccess = (data) => {
    // console.log("success", data?.data);
    toast.success(data?.data?.msg, "Success");
    setChangePasswordModel(false);
  };

  const onChangePasswordError = (data) => {
    // console.log("error", data?.data);
    toast.error(data?.response?.data?.msg, "An Error Occured");
  };

  const { mutate: changePasswordMutate, isLoading: changePasswordLoading } =
    useMutation(changePasswordFunction, {
      onSuccess: onChangePasswordSuccess,
      onError: onChangePasswordError,
    });

  //------- Delete Single Entry -------

  const deleteASHandler = async (values) => {
    const body = new FormData();
    body.append("id", values?.id);
    // console.log(values.id);
    return await axios.post(
      `${Config.apiUrl}/deleteregistrarassistant`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  };

  const onDeleteSuccess = (data) => {
    if (data?.data?.status == "OK") {
      refetch();
      setSelectedData("");
      setOpenDeleteModel(false);
      toast.success(data?.data?.msg || "Success");
    } else toast.error(data?.data?.msg || "Error");
  };

  const onDeleteError = (data) => {
    setOpenDeleteModel(false);
    setSelectedData("");
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteLoading, mutate: deleteASMutate } = useMutation(
    deleteASHandler,
    {
      onSuccess: onDeleteSuccess,
      onError: onDeleteError,
    }
  );
  return (
    <>
      <Navbar />
      {changePasswordModel && (
        <ChangePasswordModal
          setChangePasswordModel={setChangePasswordModel}
          changePasswordLoading={changePasswordLoading}
          changePasswordMutate={changePasswordMutate}
        />
      )}
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("SubRegistrarTitle")}</Title>
              <Underline />
            </div>
            <Uploader setOpenUploadModel={setOpenUploadModel} t={t} />
          </div>
          {openUploadModel && (
            <AddSubRegistrarModel
              postSingleEntry={postSingleEntry}
              SingleEntryLoading={SingleEntryLoading}
              setOpenUploadModel={setOpenUploadModel}
            />
          )}

          {editUser && (
            <EditSubRegistrarModel
              editSingleEntry={editSingleEntry}
              editEntryLoading={editEntryLoading}
              setEditUser={setEditUser}
              data={data?.data}
              selectedData={selectedData}
            />
          )}
          {openDeleteModel && (
            <DeleteSubRegistrar
              deleteLoading={deleteLoading}
              setOpenDeleteModel={setOpenDeleteModel}
              selectedData={selectedData}
              deleteASMutate={deleteASMutate}
              deviceId={selectedData.id}
            />
          )}
          <TableWrapper>
            <Table
              ApiData={error ? [] : data?.data?.data}
              setOpenDeleteModel={setOpenDeleteModel}
              setSelectedData={setSelectedData}
              setEditUser={setEditUser}
              setChangePasswordModel={setChangePasswordModel}
            />
          </TableWrapper>
        </BoxContainer>
      </Page>
    </>
  );
};

const Uploader = ({ setOpenUploadModel, t }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>{t("SubRegistrarTitle")}</p>
      </Button>
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default SubRegistrar;
